export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">深度策划，发现漫画的更多可能</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Item 1 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[4/3] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20scene%2C%20hunter%20fighting%20giant%20monster%20in%20dungeon%2C%20epic%20scale%2C%20dynamic%20lighting%2C%20dark%20atmosphere%20with%20warm%20orange%20glow%2C%20webtoon%20style&width=800&height=600&seq=carousel-01&orientation=landscape"
                alt="韩漫推荐：年度必看TOP10"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block bg-primary-500 text-background-50 text-[10px] px-2 py-0.5 rounded font-medium mb-1.5">韩漫推荐</span>
                <h3 className="text-sm font-medium text-background-50">年度必看韩漫TOP10</h3>
              </div>
            </div>
            <div className="p-3">
              <p className="text-xs text-foreground-500 leading-relaxed">从年度口碑到隐藏神作，盘点2024最值得追的韩漫佳作。</p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[4/3] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20manga%20new%20series%20showcase%2C%20various%20manga%20covers%20arranged%20artistically%2C%20colorful%20and%20vibrant%2C%20shounen%20and%20slice%20of%20life%20mix%2C%20clean%20white%20background%20with%20soft%20shadows&width=800&height=600&seq=carousel-02&orientation=landscape"
                alt="日漫大全：七月新番全解析"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block bg-accent-500 text-background-50 text-[10px] px-2 py-0.5 rounded font-medium mb-1.5">日漫大全</span>
                <h3 className="text-sm font-medium text-background-50">七月新番全解析</h3>
              </div>
            </div>
            <div className="p-3">
              <p className="text-xs text-foreground-500 leading-relaxed">热血、日常、奇幻全覆盖，七月日漫新番哪部值得追？</p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[4/3] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20ancient%20fantasy%20scene%2C%20cultivator%20flying%20above%20clouds%20with%20sword%2C%20traditional%20Chinese%20landscape%20with%20mountains%2C%20ink%20painting%20style%2C%20golden%20and%20jade%20colors&width=800&height=600&seq=carousel-03&orientation=landscape"
                alt="国漫排行榜：古风仙侠神作巡礼"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block bg-secondary-500 text-background-50 text-[10px] px-2 py-0.5 rounded font-medium mb-1.5">国漫排行榜</span>
                <h3 className="text-sm font-medium text-background-50">古风仙侠神作巡礼</h3>
              </div>
            </div>
            <div className="p-3">
              <p className="text-xs text-foreground-500 leading-relaxed">从经典到新锐，国漫古风仙侠类必看作品大盘点。</p>
            </div>
          </div>

          {/* Item 4 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[4/3] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20reading%20cozy%20scene%2C%20person%20reading%20comics%20on%20tablet%20in%20warm%20lighting%2C%20bookshelf%20background%2C%20relaxing%20atmosphere%2C%20modern%20minimal%20interior%2C%20warm%20orange%20and%20cream%20tones&width=800&height=600&seq=carousel-04&orientation=landscape"
                alt="漫荒急救：冷门高分作品特辑"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block bg-primary-500 text-background-50 text-[10px] px-2 py-0.5 rounded font-medium mb-1.5">编辑精选</span>
                <h3 className="text-sm font-medium text-background-50">漫荒急救：冷门高分特辑</h3>
              </div>
            </div>
            <div className="p-3">
              <p className="text-xs text-foreground-500 leading-relaxed">评分超高却鲜为人知的隐藏佳作，漫荒时期的最佳解药。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}